export const DisputeStatus = [
  "pending",
  "sent",
  "resolved",
  "rejected",
] as const;
export type DisputeStatus = (typeof DisputeStatus)[number];
